<template>

    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-dark py-lg-0 main-navbar" :class="{'col-md-7 col-sm-10 col-12 mx-auto': guest }">

            <inertia-link class="navbar-brand mr-auto"
                          :href="route('nl.employeedashboard.dashboard')">
                <img src="/img/logo-white.svg">
            </inertia-link>

        <ul class="navbar-nav" v-if="guest">
                <template v-for="(language, locale) in $page.props.available_languages">
                    <li class="nav-item" v-if="locale !== $page.props.locale" :key="locale">
                        <a
                            :href="switchLanguage(locale)"
                            :hreflang="locale"
                            rel="alternate"
                            class="nav-link font-poppins font-weight-medium py-2"
                        >
                            {{ language }}
                        </a>
                    </li>
                </template>
            </ul>

            <template v-if="!guest">
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTop"
                        aria-controls="navbarTop" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse ml-auto" id="navbarTop">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item" :class="{'active' : isUrl(route('nl.employeedashboard.dashboard')) }">
                            <inertia-link class="nav-link font-aileron-semibold"
                                          :href="route('nl.employeedashboard.dashboard')">
                                {{ Lang.get('employeedashboard::shared.top_nav.dashboard') }}
                            </inertia-link>
                        </li>
                        <li class="nav-item"
                            :class="{'active' : isUrl(route('nl.employeedashboard.bookings.overview')) }">
                            <inertia-link class="nav-link font-aileron-semibold"
                                          :href="route('nl.employeedashboard.bookings.overview')">
                                {{ Lang.get('employeedashboard::shared.top_nav.bookings') }}
                            </inertia-link>
                        </li>
                        <li class="nav-item">
                        <span class="nav-link font-aileron-bold" href="#">
                            {{ $page.props.auth.user.available_budget | toCurrency }}
                        </span>
                        </li>

                        <li class="nav-item d-flex align-items-center mx-2 mx-lg-4">
                            <inertia-link
                                class="font-aileron-bold py-1 btn btn-white radius-19 btn-search-and-book px-4 text-fire-orange"
                                :href="route('nl.employeedashboard.searchAndBook')">
                                {{ Lang.get('employeedashboard::shared.top_nav.search_and_book') }}
                            </inertia-link>
                        </li>

                        <li class="nav-item"
                            :class="{'active' : isUrl(route('nl.employeedashboard.settings.overview')) }">
                            <inertia-link class="nav-link font-aileron-semibold"
                                          :href="route('nl.employeedashboard.settings.overview')">
                                <img src="/img/employee-dashboard/icon-settings.svg" class="mr-1 mr-md-0">
                                <span class="d-inline-block d-md-none">
                                {{ Lang.get('employeedashboard::shared.top_nav.settings') }}
                            </span></inertia-link>
                        </li>
                        <li class="nav-item">
                            <inertia-link class="nav-link font-aileron-semibold"
                                          :href="route('nl.employeedashboard.logout')">
                                <img src="/img/employee-dashboard/icon-logout.svg" class="mr-1 mr-md-0">
                                <span class="d-inline-block d-md-none">
                                {{ Lang.get('employeedashboard::shared.top_nav.logout') }}
                            </span>
                            </inertia-link>
                        </li>
                    </ul>
                </div>
            </template>

        </nav>
    </div>

</template>

<script>
export default {

    props: {
        url: String,
        guest: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        isUrl(...urls) {
            if (urls[0] === '') {
                return this.url === ''
            }
            return urls.filter(url => this.url.startsWith(url)).length;
        },
        home() {
            return location.host;
        },
        switchLanguage(newLocale) {
            const url = new URL(location.href);

            url.pathname = url.pathname.replace(
                `/${this.$page.props.locale}/`,
                `/${newLocale}/`
            );

            return url.toString();
        },
    },
}
</script>
